import { forwardRef, type Ref, type SVGProps } from "react";
const IconGlobeFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M15 21v-4H9a22 22 0 0 0 .52 4zm-8-4H2a14 14 0 0 0 .89 4h4.6A23 23 0 0 1 7 17m10 0v4h5.47a22 22 0 0 0 .53-4zm8 0a23 23 0 0 1-.49 4h4.6a14 14 0 0 0 .89-4zm-1-8h4.17a14 14 0 0 0-8.07-6.36A13.83 13.83 0 0 1 24 9m-7-5.84V9h4.88C20.74 5.82 18.9 3.72 17 3.16M25 15h5a14 14 0 0 0-.89-4h-4.6a23 23 0 0 1 .49 4m-8-4v4h6a22 22 0 0 0-.52-4zm0 12v5.84c1.9-.56 3.74-2.66 4.88-5.84zm7 0a13.83 13.83 0 0 1-3.9 6.36A14 14 0 0 0 28.16 23zm-13.88 0c1.14 3.18 3 5.28 4.88 5.84V23zM8 23H3.84a14 14 0 0 0 8.07 6.36A13.83 13.83 0 0 1 8 23m7-14V3.16c-1.9.56-3.74 2.66-4.88 5.84zm-3.09-6.36A14 14 0 0 0 3.84 9H8a13.83 13.83 0 0 1 3.91-6.36M15 15v-4H9.53A22 22 0 0 0 9 15zm-7.51-4h-4.6A14 14 0 0 0 2 15h5a23 23 0 0 1 .49-4"
    />
  </svg>
);
const ForwardRef = forwardRef(IconGlobeFilledSVG);
ForwardRef.displayName = "IconGlobeFilled";
export { ForwardRef as IconGlobeFilled };
